











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TextWithValue extends Vue {
	@Prop({ type: String, required: false, default: 'text-gold' })
	textClass!: string;

	@Prop({ type: String, required: false, default: 'text-orange' })
	valueClass!: string;
}
